import { render, staticRenderFns } from "./InputGroupIngredients.vue?vue&type=template&id=0d48baa4"
import script from "./InputGroupIngredients.vue?vue&type=script&lang=js"
export * from "./InputGroupIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports